var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import preserveRedirectRouteQuery from './PreserveRedirectRouteQuery.gql';
import ProductPathnameRedirectQuery from './ProductPathnameRedirectQuery.gql';
import CategoryPathnameRedirectQuery from './CategoryPathnameRedirectQuery.gql';
import StartPagePathnameRedirectQuery from './StartPagePathnameRedirectQuery.gql';
import PagePathnameRedirectQuery from './PagePathnameRedirectQuery.gql';
const PathnameRedirectQueryMap = {
    Product: ProductPathnameRedirectQuery,
    Category: CategoryPathnameRedirectQuery,
    StartPage: StartPagePathnameRedirectQuery,
    Page: PagePathnameRedirectQuery
};
export function primaryRouteForPathFetcher(client) {
    return (path, newChannel, setSelectedChannel) => __awaiter(this, void 0, void 0, function* () {
        try {
            if (!path) {
                throw new Error('No path was provided');
            }
            const routeQueryResult = yield client.query({
                query: preserveRedirectRouteQuery,
                variables: {
                    path
                }
            });
            const { id, __typename, pageId } = routeQueryResult.data.route.object;
            const idUesdForRedirect = id || pageId;
            setSelectedChannel(newChannel);
            const pathnameQueryResult = yield client.query({
                fetchPolicy: 'network-only',
                query: PathnameRedirectQueryMap[__typename],
                variables: {
                    id: idUesdForRedirect
                }
            });
            return pathnameQueryResult.data[__typename].primaryRoute.path;
        }
        catch (e) {
            return '/';
        }
    });
}
//# sourceMappingURL=redirectUtils.js.map